import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { CsvSettingsModalComponent } from './components/csv-settings-modal/csv-settings-modal.component';
import { AboutInfoModalComponent } from './components/about-info-modal/about-info-modal.component';
import { CreditBalanceModalComponent } from './components/credit-balance-modal/credit-balance-modal.component';
import { InboxIntelSettingsModalComponent, InboxintelDeauthorizationComponent } from './components/inboxintel';
import { TreeviewModule } from '../shared/components/tree-view';
import { FilterlistPipeModule } from '../shared/pipes';
import { ChipsInputFormFieldModule, DataTableModule, GroupMappingModule, SiModalModule } from '../shared/components';
import { NumberWithCommaDirectiveModule } from '../shared/directives';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { HasPlansPipeModule } from '../shared/pipes/has-plans';
import { IntentModule } from '../shared/modules/intent/intent.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';

@NgModule({
    declarations: [
        AboutInfoModalComponent,
        CreditBalanceModalComponent,
        CsvSettingsModalComponent,
        InboxIntelSettingsModalComponent,
        InboxintelDeauthorizationComponent,
    ],
    imports: [
        DisableAutocompleteDirectiveModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        TreeviewModule.forRoot(),
        FilterlistPipeModule,
        GroupMappingModule,
        NumberWithCommaDirectiveModule,
        SiModalModule,
        ScrollingModule,
        HasPlansPipeModule,
        IntentModule,
        MatButtonModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatMenuModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        ChipsInputFormFieldModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        DataTableModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatNativeDateModule
    ],
})
export class SettingsModule {}
